<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size: 15px; font-weight: bold"
          >update supplier</small
        >
      </legend>
      <div>
        <form @submit.prevent="updateSupplier()">
          <div class="row">
            <input type="hidden" class="id" :value="Supplier.id" />
            <div class="col-md-4">
              <div class="form-group">
                <label>Supplier name</label>
                <input
                  type="text"
                  class="form-control supplier_name"
                  placeholder="supplier name"
                  required
                  :value="Supplier.supplier_name"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Contact person</label>
                <input
                  type="text"
                  class="form-control contact_person"
                  placeholder="contact person"
                  :value="Supplier.contact_person"
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Phone number</label>
                <input
                  type="text"
                  class="form-control phone_number"
                  placeholder="phone number"
                  :value="Supplier.phone_number"
                />
              </div>
            </div>
          </div>
          <button
            type="submit"
            class="btn btn-primary btn-flat updatingSupplier btn-rounded"
          >
            <i class="fa fa-edit"></i> update supplier
          </button>
          <button
            type="button"
            class="btn btn-primary btn-flat updatingSupplierLoader btn-rounded"
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i> please
            wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index";
import $ from "jquery";
export default {
  created() {
    if (this.$store.getters.Supplier.length === 0) {
      router.push("/managesuppliers");
    }
  },
  computed: {
    ...mapGetters(["Supplier"]),
  },
  methods: {
    ...mapActions(["updateSupplier"]),
  },
};
</script>
<style scoped>
.updatingSupplierLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/suppliers/updatesupplier.vue